import { create } from 'zustand';

const state = { status: null, title: '', description: '', onSubmit: () => {}, isLoading: false, submitOptions: {},cancelOptions: {} };

export const usePopUp = create((set) => ({
    ...state,
    onChangePopUp: (newState) => set((state) => ({ ...state, ...newState })),
    onResetPopUp: () => set(() => ({ ...state })),
}));
